/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Status_TitleInputs */

const en_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance Status`)
};

const de_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand der Vereinbarkeit`)
};

const fr_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut de conformite`)
};

const es_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de conformidad`)
};

const it_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato di conformita`)
};

const nl_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformiteitsstatus`)
};

const pl_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status zgodnosci`)
};

const fi_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaatimustenmukaisuuden tila`)
};

const da_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overholdelsesstatus`)
};

const sv_a11y_statement_status_title = /** @type {(inputs: A11y_Statement_Status_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overensstammelsestatus`)
};

/**
* | output |
* | --- |
* | "Compliance Status" |
*
* @param {A11y_Statement_Status_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_status_title = /** @type {((inputs?: A11y_Statement_Status_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Status_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_status_title(inputs)
	if (locale === "fr") return fr_a11y_statement_status_title(inputs)
	if (locale === "es") return es_a11y_statement_status_title(inputs)
	if (locale === "it") return it_a11y_statement_status_title(inputs)
	if (locale === "nl") return nl_a11y_statement_status_title(inputs)
	if (locale === "pl") return pl_a11y_statement_status_title(inputs)
	if (locale === "fi") return fi_a11y_statement_status_title(inputs)
	if (locale === "da") return da_a11y_statement_status_title(inputs)
	if (locale === "sv") return sv_a11y_statement_status_title(inputs)
	return en_a11y_statement_status_title(inputs)
});